import { useState, useEffect } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Grid, TextField, Button } from '@material-ui/core';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Searches } from '../../api/api';
import { SearchType } from '../../models/search.interface';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    alertNoMargin: {
      width: '100%',
    },
    dialogContent: {
      overflow: 'hidden',
    },
    gridSpacer: {
      minHeight: '12px',
    },
  }),
);

interface IEditSearchDialog {
  open: boolean
  onClose: () => void
  searchId: string
  fieldName: string
  lotNumber?: string
  sellerName?: string
} 

export const EditSearchDialog = (props: IEditSearchDialog) => {
  const classes = useStyles();
  const [ error, setError ] = useState<string>('');
  const [ response, setResponse ] = useState<SearchType>()
  const label = props.fieldName === 'lotNumber' ? 'Lot Number' : 'Seller'
  const [ lotNum, setLotNum ] = useState<string | undefined>()
  const [ seller, setSeller ] = useState<string | undefined>()

  useEffect(() => {
    setLotNum(props.lotNumber)
    setSeller(props.sellerName)
  },[props])

  const handleSave = () => {
    Searches.updateSearch(props.searchId, lotNum, seller)
      .then((search) => {
        setResponse(search)
      })
  }

  const handleClose = () => {
    props.onClose()
    setError('')
    setResponse(undefined)
    setLotNum(undefined)
    setSeller(undefined)
  }

  return ( 
    <Dialog 
      onClose={() => {props.onClose()}}
      aria-labelledby="edit-search-dialog-title" 
      open={props.open}
    >
      <DialogTitle id="submit-dialog-title">Update {label}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {error.length > 0   &&    
          <Grid container>
            <Alert severity="error" className={classes.alertNoMargin} >
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>   
            <div className={classes.gridSpacer} />
          </Grid>
        } 
        {response &&    
          <Grid container className={classes.gridSpacer} >
            <Alert className={classes.alertNoMargin} >
              
              {label} Saved
            </Alert>   
            <div className={classes.gridSpacer} />
          </Grid>
        } 
        <Grid container className={classes.gridSpacer}/>
        <Grid container>
          { props.fieldName === 'seller' &&
            <TextField
            id="seller"
            label={label}
            fullWidth
            variant="outlined"
            size="medium"
            required
            onChange={(e) => setSeller(e.target.value)}
            value={seller}
            color="primary"
          />
          }
          { props.fieldName === 'lotNumber' &&
            <TextField
              id="lotNum"
              label={label}
              fullWidth
              variant="outlined"
              size="medium"
              required
              onChange={(e) => setLotNum(e.target.value)}
              value={lotNum}
              color="primary"
            />
          }
        </Grid>
      </DialogContent>
      { response 
        ? <DialogActions>
            <Button 
              onClick={handleClose}
              color="primary"
              variant="outlined"
            >
              Close
            </Button>
          </DialogActions>
        : <DialogActions>
            <Button 
              onClick={handleClose}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSave} 
              color="primary"             
              variant="contained"
              startIcon={<SaveOutlinedIcon fontSize="small" />}
              autoFocus
            >
              Save
            </Button>
          </DialogActions>
      }
    </Dialog>
  );
}
